/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import GridList from "./GridList";
import { PageWrapper } from "../../../shared/layout";
import { templateStrings, roleBasedHiddenItems } from "../../../Constant";
import { roles, CityWiseId } from "../../../lib/constants";
import "./overview.css";
import NavFilter from "../../../shared/widgets/navFilter/navFilter";
import { selectedOperationType } from "../../../redux/actions/operationTypeAction";

import {
  fetchAllOverviewData,
} from "../../../redux/action-creators/overviewActionCreator";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import ButtonToolbarRangePicker from "../../../shared/components/commonComponents/ButtonToolbarRangePicker";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tab: {
    marginLeft: theme.spacing(4),
  },
  picker: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-15px",
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
}));

const determineGridItems = (
  content,
  financialContent,
  gcOverviewContent,
  onlineRecharge,
  user,
) => {
  const gridItemsData = content;
  gridItemsData.mobileProducts = gridItemsData.mobileProducts || {};
  gridItemsData.mobileProducts.mobileRechargesDone = onlineRecharge?.soldCount || 0;
  gridItemsData.onlineRecharge = onlineRecharge?.salesValue || 0;
  gridItemsData.amountSettled = financialContent?.amountSettled || {};
  gridItemsData.currentOutstanding = financialContent?.currentOutstanding || {};
  gridItemsData.finalProfit = gcOverviewContent?.finalProfit || 0;
  gridItemsData.finalProfitBreakDown = gcOverviewContent?.finalProfitBreakDown || {};

  let gridStrings = templateStrings.roleBasedOverviewGridItems;
  const gridType = "roleBasedOverviewGridItems";

  gridStrings = JSON.parse(JSON.stringify(gridStrings));

  if (
    user?.cityIds?.includes(CityWiseId.Mumbai)
    && user.role === roles.agencyManager
  ) {
    delete gridStrings.averageBuses;
  }

  if (
    (user?.cityIds?.includes(CityWiseId.Indore)
      && user.role !== roles.agencyManager)
    || !user?.cityIds?.includes(CityWiseId.Indore)
  ) {
    delete gridStrings.totalGpsDistance;
  }
  return { gridItemsData, gridStrings, gridType };
};

const fetchDataBasedOnUserAndFilters = ({
  user,
  cityFilter,
  operatorFilter,
  selectedDateFilter,
  selectedOperation,
  fetchAllOverviewDataProp,
}) => {
  if (
    user.role
    && (user.role !== roles.operator || cityFilter.length)
  ) {
    fetchAllOverviewDataProp(
      {
        operatorFilter,
        cityFilter,
        dateFilter: selectedDateFilter,
        operationType: selectedOperation,
      },
      "collectionLoader",
    );
  }
};

function OverviewList(props) {
  const {
    collectionLoader, selectedOperationType: selectedOperationTypeProp, user, cityFilter,
    fetchAllOverviewData: fetchAllOverviewDataProp,
    operatorFilter, selectedDateFilter, selectedOperation,
    content, financialContent, gcOverviewContent,
    onlineRecharge, operationType,
    refreshUpliftStatus, selectDateFilter: selectDateFilterProp,
  } = props;
  const classes = useStyles();

  const [selectOperationList, setSelectOperationList] = React.useState([]);
  const [operationHeader, setOperationHeader] = React.useState("All");
  const isLoading = React.useMemo(
    () => collectionLoader,
    [collectionLoader],
  );

  React.useEffect(() => {
    selectedOperationTypeProp("");
  }, []);

  React.useEffect(() => {
    fetchDataBasedOnUserAndFilters({
      user,
      cityFilter,
      operatorFilter,
      selectedDateFilter,
      selectedOperation,
      fetchAllOverviewDataProp,
    });
  }, [
    operatorFilter,
    cityFilter,
    selectedDateFilter,
    selectedOperation,
  ]);

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      selectDateFilterProp({ fromDate, toDate });
    }
  };

  const handleOperationTypeSelection = async (operationTypeProp) => {
    if (operationTypeProp === "All") {
      selectedOperationTypeProp("");
    } else {
      selectedOperationTypeProp(operationTypeProp);
    }
  };

  const { gridItemsData, gridStrings, gridType } = determineGridItems(
    content,
    financialContent,
    gcOverviewContent,
    onlineRecharge,
    user,
  );

  const setHeader = (source, header) => {
    source === "operationType" && setOperationHeader(header);
  };

  const setSelected = (source, data) => {
    source === "operationType" && setSelectOperationList(data);
  };

  return (
    <div className={classes.root}>
      <PageWrapper>
        {/* <HiddenRangePicker
          handleDatesChange={handleDatesChange}
          fromDate={selectedDateFilter.fromDate}
          toDate={selectedDateFilter.toDate}
          pickerClasses={classes.picker}
        /> */}
        <PageWrapper.Header heading="Overview" hideS>
          <div className="pull-right">
            <NavFilter
              source="operationType"
              options={operationType}
              onMenuSelection={handleOperationTypeSelection}
              selected={selectOperationList}
              setSelected={setSelected}
              setHeader={setHeader}
              filterHeader={operationHeader || "All"}
            />
          </div>
          <Hidden only={["sm", "xs"]}>
            {refreshUpliftStatus && (
              <div className="pull-right">
                <div className="progress-heading">
                  <span>{refreshUpliftStatus}</span>
                </div>
              </div>
            )}
            <div className="pull-right">
              <ButtonToolbarRangePicker
                handleDatesChange={handleDatesChange}
                fromDate={selectedDateFilter.fromDate}
                toDate={selectedDateFilter.toDate}
              />
            </div>
          </Hidden>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <div className="custom-grid-layout">
            {Object.keys(gridStrings).map((column, index) => {
              if (
                (roleBasedHiddenItems[(user || {}).role] || []).includes(
                  column,
                )
              ) return null;
              return (
                <div key={index} className="custom-grid custom-grid-overview">
                  <GridList
                    isLoading={isLoading}
                    value={gridItemsData[column]}
                    gridItemsData={gridItemsData}
                    template={column}
                    type={gridType}
                    containerClass="overview-section"
                  />
                </div>
              );
            })}
          </div>
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content: state.Overview.overviewSummary,
    financialContent: state.Overview.financialOverview,
    gcOverviewContent: state.Overview.gcOverview,
    onlineRecharge: state.Overview.onlineRecharge,
    cityFilter: state.Cities.selectedCity,
    collectionLoader: state.loadingBar && state.loadingBar.collectionLoader,
    user: state && state.Auth && state.Auth.user,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
    operationType: state.OperationType.operationType,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchAllOverviewData: (params, loaderScope) => {
    dispatch(fetchAllOverviewData(params, loaderScope));
  },
  selectedOperationType: (params) => {
    dispatch(selectedOperationType(params));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OverviewList);
